import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';

import SimpleBreadcrumbs from 'components/SimpleBreadcumbs';
import CustomSwitch from 'components/CustomSwitch';

import userServices from "dataServices/userServices";
import { getSettingsByAdmin, updateSettingsByAdmin } from 'dataServices/AdminPageServices/settings';

import actionTypes from "reduxjs/actionTypes";
import { GENERAL_SETTINGS } from './constants';
const ADMIN_ROLE_ARRAY = ["superAdmin", "licenseeAdmin", "challengeAdmin", "admin"];

import styles from './styles.module.scss';

const Settings = props => {
  const { setRedirectOnError, setLoadingSpinner, resetLoadingSpinner } = props;

  const [settings, setSettings] = useState([]);
  const [isUpdatingSettings, setIsUpdatingSettings] = useState(false);

  const fetchSettings = async () => {
    setLoadingSpinner();

    try {
      const fetchedSettings = await getSettingsByAdmin();

      if (get(fetchedSettings, 'status', 500) != 200) {
        setSettings([]);
        resetLoadingSpinner();
        return;
      }

      setSettings(get(fetchedSettings, 'settings', []));
      resetLoadingSpinner();
    } catch (error) {
      resetLoadingSpinner();
    }
  };

  const fetchCurrentUser = () => {
    setLoadingSpinner();

    userServices.getCurrentUser()
      .then((data) => {
        let isAdmin = false;

        get(data, "roles", []).forEach(role => {
          if (ADMIN_ROLE_ARRAY.includes(role.RoleId)) {
            isAdmin = true;
          }
        });

        if (isAdmin) {
          fetchSettings();
        } else {
          resetLoadingSpinner();
          setRedirectOnError("/dashboard/index");
        }
      })
      .catch((err) => {
        resetLoadingSpinner();
        setRedirectOnError("/dashboard/index");
      });
  };

  const onChangeBooleanSettingsValue = async (settingsName, newValue) => {
    setLoadingSpinner();
    setIsUpdatingSettings(true);

    try {
      await updateSettingsByAdmin(settingsName, newValue);
      await fetchSettings();

      setIsUpdatingSettings(false);
    } catch (error) {
      setIsUpdatingSettings(false);
      resetLoadingSpinner();
    }
  }

  const renderBreadcrumbs = () => {
    const breadcrumbsItems = [
      { name: 'Dashboard', link: '/dashboard/index' },
      { name: 'General Settings', link: '/dashboard/settings' }
    ];

    return <SimpleBreadcrumbs breadLinkData={breadcrumbsItems} />;
  };

  const renderSettingsWithBooleanValue = (booleanValueSettings) => {
    const settingsForFilterTag = settings.find(
      value => value.settingsName == booleanValueSettings.settingsName
    );

    return (
      <div className={styles.settingsComponent}>
        <CustomSwitch
          color='primary'
          checked={get(settingsForFilterTag, 'settingsValue.value', false)}
          disabled={isUpdatingSettings}
          onChange={
            (e) => onChangeBooleanSettingsValue(
              booleanValueSettings.settingsName,
              e.target.checked
            )
          }
        />
        <div>{booleanValueSettings.title}</div>
      </div>
    );
  };

  const renderAllSettingsWithBooleanValue = () => {
    const settingsWithBooleanValue = [
      GENERAL_SETTINGS.SHOW_FILTER_BY_TAG_SECTION,
      GENERAL_SETTINGS.SHOW_CHALLENGE_STATUS_FILTER,
    ]

    return settingsWithBooleanValue.map(value => renderSettingsWithBooleanValue(value));
  };

  useEffect(() => {
    fetchCurrentUser();
  }, [])

  return (
    <div style={{ height: '100%', overflowY: 'auto' }}>
      {renderBreadcrumbs()}
      <div className={styles.settingsComponentWrapper}>
        {renderAllSettingsWithBooleanValue()}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoadingSpinner: () => dispatch({ type: actionTypes.LOADING_SPINNER_SET }),
    resetLoadingSpinner: () => dispatch({ type: actionTypes.LOADING_SPINNER_RESET }),
    showAlert: (alertType, title, description) =>
      dispatch({
        type: actionTypes.SHOW_ALERT,
        payload: {
          alertType,
          title,
          description
        }
      }),
    setRedirectOnError: (redirectTo = "") =>
      dispatch({ type: actionTypes.REDIRECT_ON_ERROR, payload: redirectTo }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
